<ion-modal [isOpen]="isOpen()" (didDismiss)="onDidDismiss()" cssClass="echarts-editor-modal">
  <ng-template>
    <ion-header>
      <ion-toolbar class="px-3">
        <div slot="start" class="flex items-center">
          <ion-title class="font-primary pl-0 text-lg font-semibold">Edit ECharts</ion-title>
        </div>
        <div slot="end" class="flex items-center gap-2">
          <a [href]="docsUrl" target="_blank" rel="noopener noreferrer" class="docs-link"> Documentation </a>
          <dojo-button fill="outline" size="s" (click)="cancel()">Cancel</dojo-button>
          <dojo-button size="s" (click)="save()" [disabled]="jsonCtrl.invalid">Save</dojo-button>
        </div>
      </ion-toolbar>
    </ion-header>

    <ion-content [scrollY]="false">
      <div class="editor-layout">
        <div class="left-panel">
          <div class="monaco-section">
            <label class="panel-label">ECharts Options (JSON)</label>
            <div class="monaco-container">
              <dojo-json-editor dojoEchartsJsonEditor [formCtrl]="jsonCtrl" />
            </div>
          </div>

          <div class="height-section">
            <dojo-number-input
              label="Render Height (px)"
              [formCtrl]="heightCtrl"
              [min]="100"
              [max]="800"
              [step]="10"
              size="s"
            />
          </div>
        </div>

        <div class="preview-panel">
          <label class="panel-label">Preview</label>
          @if (previewOptions()) {
            <dojo-echarts-svg [options]="previewOptions()!" [style.height.px]="heightCtrl.value" />
          } @else {
            <div class="preview-placeholder">Fix JSON errors to see preview</div>
          }
        </div>
      </div>
    </ion-content>
  </ng-template>
</ion-modal>
